{
  "total": "มูลค่าทรัพย์สินรวม",
  "available": "ยอดคงเหลือที่ใช้ได้",
  "frozen": "สินทรัพย์ที่ถูกล็อก",
  "bonus-balance": "ยอดคงเหลือโบนัส",
  "bonus-balance-label": "ยอดคงเหลือโบนัส: {{amount}}",
  "action": {
    "deposit": "รับเหรียญ",
    "convert": "แลกเปลี่ยน",
    "buySellOrder": "ซื้อขายเหรียญ",
    "customerService": "ฝ่ายบริการลูกค้า"
  },
  "assets": "สินทรัพย์",
  "coin": {
    "YBB": "โทเค็นแพลตฟอร์ม",
    "usdt": "USDT"
  },
  "ticketUsed": "บัตรจับรางวัลนี้ถูกใช้ไปแล้วหรือใช้ไม่ได้",
  "ticketWin": "ยินดีด้วย คุณได้รับ {{amount}}{{label}}",
  "ticketNoPrize": "ยังไม่ถูกรางวัล ลองใหม่อีกครั้ง!",
  "tickets": "บัตรจับรางวัล",
  "close": "ปิด",
  "ticketLoadFailed": "ไม่สามารถโหลดบัตรจับรางวัลได้ โปรดลองอีกครั้งภายหลัง",
  "noTickets": "ขณะนี้ไม่มีบัตรจับรางวัล",
  "unclaimedTicket": "คุณมีอั่งเปาที่ยังไม่ได้รับ แตะเพื่อรับเลย!",
  "drawNow": "จับรางวัลตอนนี้",
  "loginToViewTickets": "โปรดเข้าสู่ระบบก่อนดูบัตรจับรางวัล",
  "drawResultUnavailable": "ไม่สามารถรับผลการจับรางวัลได้ โปรดลองอีกครั้งภายหลัง",
  "drawFailed": "จับรางวัลไม่สำเร็จ โปรดลองอีกครั้งภายหลัง",
  "drawFailedTitle": "จับรางวัลไม่สำเร็จ"
}
